globalThis.appVisitor = globalThis.appVisitor || {};

appVisitor.StickedFooter = (function()
{
  function StickedFooter() {
    this.$site      = $('#body-container-inner');
    this.siteH      = this.$site[0].offsetHeight;
    this.$content   = $('#center_inner');
    this.windowH    = $(window).height();
    this.topGutter  = 0;
    this.bottomGutter;
    this.init();
  }

  StickedFooter.prototype =
  {
    init : function(){
      var me = this;
      var visitorRouter = new appVisitor.Router();

      if(this.siteH < this.windowH) {
        if(visitorRouter.isContextContent() || visitorRouter.isContextPages()) {
          this._setTopGutter(this.$site.offset().top);
        }
        this._setBottomGutter(this.windowH - this.siteH);
        if(this.$content.length === 1) {
          this.$content.css({
            minHeight : me.$content[0].offsetHeight + this.bottomGutter - this.topGutter + 'px'
          });
        }
      }
    },
    _setBottomGutter: function(gutter){
      this.bottomGutter = gutter;
    },
    _setTopGutter: function(gutter){
      this.topGutter = gutter;
    }
  }
  return StickedFooter;
})();
